import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-add-gps",
  templateUrl: "./admin-add-gps.component.html",
  styleUrls: ["./admin-add-gps.component.css"],
})
export class AdminAddGpsComponent implements OnInit {
  GpsTypeData: any = [];
  dataSource = new MatTableDataSource<any[]>(this.GpsTypeData);
  gpsAddForm: FormGroup;
  token: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  loading: boolean = false;
  serverName: any = -1;
  perPage: any = 10;
  page: any = 1;

  constructor(
    private matdialogref: MatDialogRef<AdminAddGpsComponent>,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getGpsType();
    this.gpsAddForm = this.formBuilder.group({
      device_reference_no: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[A-Za-z0-9? ,_-]+$"),
        ]),
      ],
      provider: ["", [Validators.required]],
      contact_no: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      plan_information: ["", [Validators.required]],
      expiry_date: ["", [Validators.required]],
      request_type: ["", [Validators.required]],
    });
    if (this.data.data) {
      this.gpsAddForm.controls["device_reference_no"].disable();
      this.gpsAddForm.patchValue(this.data.data);
      this.gpsAddForm.patchValue(this.data.data.device_sim_details);
    }
  }

  close() {
    this.matdialogref.close();
  }
  public getGpsType() {
    this.service
      .GetGpsType(this.token, this.serverName, this.perPage, this.page)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.GpsTypeData = response.body.data;
            this.dataSource.data = this.GpsTypeData;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  addGPS() {
    if (this.gpsAddForm.valid) {
      this.loading = true;
      const deviceObj = {
        provider: this.gpsAddForm.value.provider,
        contact_no: this.gpsAddForm.value.contact_no,
        plan_information: this.gpsAddForm.value.plan_information,
        expiry_date: this.gpsAddForm.value.expiry_date,
      };
      const gpsObj = {
        device_reference_no: this.gpsAddForm.value.device_reference_no,
        request_type: this.gpsAddForm.value.request_type,
        device_sim_details: deviceObj,
      };
      this.service.gpsAdd(gpsObj, this.token).subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.matdialogref.close();
            this.snackBar.open("GPS added successfully", "Success", {
              duration: 5000,
            });
          }

          this.loading = false;
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  EditGps() {
    if (this.gpsAddForm.valid) {
      this.loading = true;
      const deviceObj = {
        provider: this.gpsAddForm.value.provider,
        contact_no: this.gpsAddForm.value.contact_no,
        plan_information: this.gpsAddForm.value.plan_information,
        expiry_date: this.gpsAddForm.value.expiry_date,
      };
      const gpsObj = {
        device_reference_no: this.gpsAddForm.value.device_reference_no,
        request_type: this.gpsAddForm.value.request_type,
        device_sim_details: deviceObj,
      };
      this.service.UpdateGPS(gpsObj, this.token, this.data.data._id).subscribe(
        (response: any) => {
          if (
            (response.status == 201 && response.status == 200) ||
            response.body.data
          ) {
            this.snackBar.open("GPS Updated Successfully", "Success", {
              duration: 5000,
            });
            this.matdialogref.close({ event: "Success" });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
      this.loading = false;
    } else {
      this.snackBar.open("Please Enter valid Data", "Fail", {
        duration: 5000,
      });
    }
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
